import React from "react";
import { cx } from "./Card";

export default function Pill({ children, className }) {
  return (
    <span
      className={cx(
        "inline-flex items-center rounded-md bg-neutral-200 px-2 py-1 text-xs font-semibold text-neutral-700 dark:bg-neutral-800 dark:text-neutral-200",
        className
      )}
    >
      {children}
    </span>
  );
}
